import {
  buildCardColumnIndexes,
  ensureCardsSheetColumns,
  parseCardFlagState,
} from "./cardsSheet";

export const readCards = async (metadata, spreadsheetAccessData) => {
  const { sheetTitle, values } = await ensureCardsSheetColumns(
    metadata,
    spreadsheetAccessData
  );
  const cards = [];
  const headers = values[0] ?? [];
  const indexes = buildCardColumnIndexes(headers);
  
  values.forEach((card, card_id) => {
    if (card_id > 0) {
      const flagState = parseCardFlagState(card[indexes.flagsIndex]);
      cards.push({
        front: card[indexes.frontIndex] || "",
        back: card[indexes.backIndex] || "",
        frontAdditional: card[indexes.frontAdditionalIndex] || "",
        backAdditional: card[indexes.backAdditionalIndex] || "",
        active: ["x", "true", "1", "yes"].includes(
          String(card[indexes.activeIndex] ?? "")
            .trim()
            .toLowerCase()
        ),
        muted: flagState.muted,
        flagStatus: flagState.flagStatus,
        flagged: flagState.flagged,
        reverseRequired: flagState.reverseRequired,
        persistedActive: ["x", "true", "1", "yes"].includes(
          String(card[indexes.activeIndex] ?? "")
            .trim()
            .toLowerCase()
        ),
        persistedMuted: flagState.muted,
        persistedFlagStatus: flagState.flagStatus,
        cardsSheetTitle: sheetTitle,
        cardsSheetColumns: indexes,
        sheetRowNumber: card_id + 1,
        card_id,
      });
    }
  });

  return cards;
};
export default readCards;
